export default class Theme {

  constructor(modelData, store) {

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
    this.store = store
  }

  getDefault() {
    return {
      id: null,
      mailingTypeIds: [],
      allMailingTypes: false,
      css: [],
      translations: {
        de: {
          name: null
        },
        en: {
          name: null
        }
      }
    }
  }

  set(data) {
    if (data.mailingTypes) {
      data.mailingTypeIds = data.mailingTypes.data.map(el => el.id)
    }
    Object.assign(this, data)
  }

  getJSON() {
    return {
      id: this.id,
      mailingTypeIds: this.mailingTypeIds,
      allMailingTypes: this.allMailingTypes,
      css: this.css,
      translations: this.translations,
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/theme/model.js